export enum PROJECT_STATUS {
  DRAFT = 'draft',
  SUBMITTED = 'submitted',
  REVIEW = 'review',
  REJECTED = 'rejected',
  SUSPENDED = 'suspended',
  DELETED = 'deleted',
  LIVE = 'live',
  TEST = 'test',
}

export enum PROJECT_FILTER {
  NAME = 'name',
  ID = 'id',
  UPDATED = 'updated',
  STATUS = 'status',
  EMPTY = '',
}

export type ProjectSectionType = 'alert' | 'complete' | undefined;
